import { useEffect } from "react";
import { useSelector } from "react-redux";

export default function MyCalendar({
  inputMonth = null,
  inputYear = null,
  inputNumOfRow = 5,
  onOpenEventList = () => {},
  eventList = [],
  // eventList = [
  //   {
  //     id_list:1,
  //     start_date:"2025-01-31",
  //     end_date:"2025-01-31",
  //     start_time: "11:30",
  //     end_time: "13:45",
  //     title:"",
  //     onClick:()=>{},
  //   }
  // ]
}) {
  const { msg } = useSelector((s) => s.language);
  const timeToHSL = (hh, mm) => {
    const hue = Math.round((hh / 23 + mm / 59) * 360);
    const saturation = 100;
    const lightness = 80;
    return [hue, saturation, lightness];
  };
  function hslToHex(h, s, l) {
    s /= 100;
    l /= 100;

    const c = (1 - Math.abs(2 * l - 1)) * s;
    const x = c * (1 - Math.abs(((h / 60) % 2) - 1));
    const m = l - c / 2;

    let r, g, b;
    if (h >= 0 && h < 60) {
      r = c;
      g = x;
      b = 0;
    } else if (h >= 60 && h < 120) {
      r = x;
      g = c;
      b = 0;
    } else if (h >= 120 && h < 180) {
      r = 0;
      g = c;
      b = x;
    } else if (h >= 180 && h < 240) {
      r = 0;
      g = x;
      b = c;
    } else if (h >= 240 && h < 300) {
      r = x;
      g = 0;
      b = c;
    } else {
      r = c;
      g = 0;
      b = x;
    }

    r = Math.round((r + m) * 255);
    g = Math.round((g + m) * 255);
    b = Math.round((b + m) * 255);

    // Convert to hex format
    const hex = `#${((1 << 24) | (r << 16) | (g << 8) | b)
      .toString(16)
      .slice(1)
      .toUpperCase()}`;
    return hex;
  }

  const timeToHex = (hh, mm) => {
    const [h, s, l] = timeToHSL(hh, mm);
    const colorCodeHex = hslToHex(h, s, l);
    return colorCodeHex;
  };

  const dateName = [
    { id: 1, name: "MON" },
    { id: 2, name: "TUE" },
    { id: 3, name: "WED" },
    { id: 4, name: "THU" },
    { id: 5, name: "FRI" },
    { id: 6, name: "SAT" },
    { id: 0, name: "SUN" },
  ];
  const numOfRow = inputNumOfRow;
  const selectMonth = inputMonth >= 0 ? inputMonth : new Date().getMonth();
  const selectYear = inputYear || new Date().getFullYear();
  const now =
    inputMonth === null && inputYear === null
      ? new Date()
      : new Date(selectYear, selectMonth, 1);
  const nowDay = now.getDay();
  const nowDate = now.getDate();
  const nowMonth = now.getMonth();
  const nowYear = now.getFullYear();
  const nowUTCYear = now.getUTCFullYear();
  const first = new Date(nowYear, nowMonth, 1);
  const last = new Date(nowYear, nowMonth + 1, 0);
  const firstDate = first.getDate();
  const firstDay = first.getDay();
  const lastDate = last.getDate();
  const lastDay = last.getDay();
  const numOfDayInFirstRow = 7 - firstDay;
  const numOfDayInHeadOfFirstRow = firstDay;
  const numOfDayInLastRow = (lastDate + numOfDayInHeadOfFirstRow) % 7;
  const numOfDayInTailOfLastRow = 7 - numOfDayInLastRow;
  const lastOfPrevMonth = new Date(nowYear, nowMonth, 0);
  const lastDateOfPrevMonth = lastOfPrevMonth.getDate();
  const lastDayOfPrevMonth = lastOfPrevMonth.getDay();
  const firstOfNextMonth = new Date(nowYear, nowMonth + 1, 1);
  const firstDateOfNextMonth = firstOfNextMonth.getDate();
  const firstDayOfNextMonth = firstOfNextMonth.getDay();
  const prevMonth = new Date(nowYear, nowMonth - 1, 1).getMonth();
  const nextMonth = new Date(nowYear, nowMonth + 1, 1).getMonth();
  const head = [];
  const mid = [];
  const tail = [];
  let temp_head = lastDateOfPrevMonth;
  while (head.length < lastDayOfPrevMonth) {
    head.push({
      tag: "head",
      date: temp_head,
      month: prevMonth,
      year: selectYear,
    });
    temp_head -= 1;
  }
  head.sort((a, b) => a.date - b.date);

  let temp_mid = 1;
  while (mid.length < lastDate) {
    mid.push({
      tag: "mid",
      date: temp_mid,
      month: selectMonth,
      year: selectYear,
    });
    temp_mid += 1;
  }
  mid.sort((a, b) => a.date - b.date);

  let temp_tail = 1;
  while (tail.length <= numOfDayInTailOfLastRow) {
    tail.push({
      tag: "tail",
      date: temp_tail,
      month: nextMonth,
      year: selectYear,
    });
    temp_tail += 1;
  }
  tail.sort((a, b) => a.date - b.date);

  const combined = [...head, ...mid, ...tail];
  const selectToShow = [];
  const limitNumOfRow = combined.length / 7;
  for (
    let i = 0;
    i < (numOfRow <= limitNumOfRow ? numOfRow : limitNumOfRow) * 7;
    i++
  ) {
    let elem = combined[i];
    elem = {
      ...elem,
      eventList: eventList
        .filter((el) => {
          // const temp_start = new Date(el.start_date);
          // const start_event_date = temp_start.getDate();
          // const start_event_month = temp_start.getMonth();
          // const start_event_year = temp_start.getFullYear();
          // const temp_end = new Date(el.end_date);
          // const end_event_date = temp_end.getDate();
          // const end_event_month = temp_end.getMonth();
          // const end_event_year = temp_end.getFullYear();
          // const { date, month, year } = elem; // month is 0-11
          // if (
          //   start_event_date <= date &&
          //   date <= end_event_date &&
          //   start_event_month <= month &&
          //   month <= end_event_month &&
          //   start_event_year <= year &&
          //   year <= end_event_year
          // ) {
          //   return true;
          // } else {
          //   return false;
          // }

          const temp_start = new Date(el.start_date).getTime();
          const temp_end = new Date(el.end_date).getTime();
          const { date, month, year } = elem; // month is 0-11

          let dd, mm, yyyy;
          if (date < 10) {
            dd = `0${date}`;
          } else {
            dd = `${date}`;
          }
          if (month + 1 < 10) {
            mm = `0${month + 1}`;
          } else {
            mm = `${month + 1}`;
          }
          yyyy = `${year}`;

          const yyyymmdd = `${yyyy}-${mm}-${dd}`;
          const getTime = new Date(yyyymmdd).getTime();

          if (temp_start <= getTime && getTime <= temp_end) {
            return true;
          } else {
            return false;
          }
        })
        .map((el) => ({
          ...el,
          color: timeToHex(
            +el.start_time.split(":")[0],
            +el.start_time.split(":")[1]
          ),
        })),
    };
    selectToShow.push(elem);
  }

  return (
    <div className="container-body-calendar">
      <div className="body-calendar">
        <div className="grid grid-cols-7 rounded-3xl border-2 border-x-1 border-[var(--soft-44)] max-h-[30rem] overflow-y-auto">
          {dateName
            .sort((el) => el.id)
            .map((el) => (
              <div
                className="py-1 px-4 font-bold text-[var(--primary)]"
                key={el.id}
              >
                {el.name}
              </div>
            ))}
          {selectToShow.map((el, index) => (
            <div
              key={index}
              className={
                "font-bold text-[1.2rem] py-1 px-4 h-[7rem] border border-[var(--soft-44)] " +
                (el.tag === "mid"
                  ? "text-[var(--primary)]"
                  : "text-[var(--soft)]")
              }
            >
              <div>{el.date < 10 ? `0${el.date}` : `${el.date}`}</div>
              <div className="text-[0.7rem] font-semibold flex flex-col justify-between h-fit">
                <div>
                  {el.eventList.length > 0 &&
                    el.eventList.slice(0, 2).map((el2, index) => (
                      <div
                        key={index}
                        onClick={el2.onClick}
                        style={{
                          backgroundColor: `${el2.color}55`,
                          borderColor: `${el2.color}`,
                        }}
                        className={`px-2 py-0 mb-1 border-l-4 cursor-pointer line-clamp-1`}
                      >
                        {el2.title.length > 15
                          ? `${el2.title.slice(0, 15)}...`
                          : el2.title}
                      </div>
                    ))}
                </div>
                {el.eventList.length > 2 && (
                  <div
                    onClick={() => onOpenEventList(el.eventList)}
                    className="flex gap-1 items-center cursor-pointer w-fit"
                  >
                    <span className="bg-[var(--secondary)] text-[var(--bright)] size-6 rounded-full flex justify-center items-center">
                      {el.eventList.length - 2}
                    </span>
                    <span className="text-[var(--primary)]">{msg.items}</span>
                  </div>
                )}
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}
